module.exports = __webpack_public_path__ + "img/NFC-1.e5978a0f.png";